<div class="dd-logo" [class.tm]="shouldShowTM">
    <img src="assets/images/logos/logo-dd.svg"
         width="100%"
         height="100%"
         alt="Delivery Defense"/>
</div>
